export default {
    active(){
        $('tr.active').removeClass('active');
		$(event.target).closest('tr').addClass('active');
    }
}



// WEBPACK FOOTER //
// ./assets/js/active.js